import React, { useState, useCallback } from 'react';
import { PortfolioConnectWidget } from './components/PortfolioConnectWidget';
import type { PortfolioConnectProps, RenderProps } from './types';

export const PortfolioConnect: React.FC<PortfolioConnectProps> = ({
  accessToken,
  apiKey,
  apiBaseUrl,
  config,
  onSubmit,
  onSuccess,
  onError,
  onExit,
  onEvent,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // `accessToken` and `apiKey` are equivalent — both send as `x-api-key`.
  // Accept whichever the embedder passes.
  const token = accessToken || apiKey;

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    onExit?.();
  }, [onExit]);

  const renderProps: RenderProps = {
    open,
    isReady: !!token,
    isOpen,
  };

  return (
    <>
      {children(renderProps)}
      <PortfolioConnectWidget
        isOpen={isOpen}
        onClose={handleClose}
        apiKey={token || ''}
        apiBaseUrl={apiBaseUrl}
        config={config}
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        onError={onError}
        onEvent={onEvent}
      />
    </>
  );
};

export default PortfolioConnect;
